<template>
  <div class="success-container g-flex-c">
    <img v-if="qrStatus === 2" src="../../../assets/image/success.png" alt="">
    <img v-else src="../../../assets/image/fail.png" alt="">
    <p class="first">{{ `报名${qrStatus === 2 ? '成功' : '失败'}` }}</p>
    <p class="last" v-if="resultText !== undefined">{{ resultText }}</p>
    <p class="last" v-else>{{ qrStatus === 2 ? '审核通过后活动生效': '未查询到油站关系请联系您的客户经理' }}</p>
    <el-button v-if="qrStatus === 2" type="primary" @click="$router.push({ path: '/promotionAudit/myPromotion', query: { type: activeType } })">查看审核列表</el-button>
    <el-button v-else type="primary" @click="$router.push({ path: '/promotion/centerShow' })">返回营销中心</el-button>
  </div>
</template>
<script>
export default {
  name: 'third',
  props: ['qrStatus', 'resultText', 'activeType'] // qrStatus 2: 成功， 其他：失败
}
</script>
<style lang="less" scoped>
  .success-container {
    flex-direction: column;
    padding-top: 120px;
    img {
      width: 90px;
      height: 90px;
    }
    .first {
      color: #222222;
      font-size: 20px;
      margin-top: 20px;
      font-weight: 600;
    }
    .last {
      width: 144px;
      color: #666666;
      font-size: 16px;
      text-align: center;
    }
    .el-button {
      width: 150px;
      margin-top: 30px;
    }
  }
</style>
